<template>
  <WorkflowActionSelect
    v-model="internalIds"
    v-bind="$props"
    :label="customLabel ? customLabel : $t('Common.workflowSteps')"
    :items="workflowactions"
    :initial-value="searchParams"
    :item-children="customChildren ? customChildren : 'data.children'"
    :item-text="customItemText ? customItemText : 'data.label'"
    :item-value="customItemValue ? customItemValue : 'id'"
    :return-object="false"
  />
</template>
<script>
// components
import WorkAutocomplete from '@/components/global_components/forms/WorkAutocomplete';

import WorkflowActionSelect from '@/components/base_components/workflow/workflow_inputs/workflow_action_picker/WorkflowActionSelect';
import dynamicData from '@/mixins/api_data/dynamic-data-mixin';

const getData = response => response.data

export default {
    name: 'WorkflowMultiActionSelectWrapper',
    components: {
        WorkflowActionSelect
    },
    props: {
        ...WorkAutocomplete.props,
        customLabel: { type: String },
        customItemText: { type: String },
        customItemValue: { type: String },
        customChildren: { type: String },
        vid: { type: String },
        value: { type: [Object, Array], default: () => [] },
        searchParams: { type: Object },
        path: { type: String, default: 'workflows/tree'},
        withFormField: { type: Boolean, default: true},
    },
    mixins: [
        dynamicData('workflowactions', self => self.path, response => getData(response))
    ],
    computed: {
        internalIds: {
            get(){
                return this.value
            },
            set(value){
                this.$emit('input', value)
            }
        },
    }
}
</script>
